import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import { FaIcon } from '../FaIcon';

const ACTION_ACCEPT = 'accept';
const ACTION_DUPLICATE = 'duplicate';

/**
 * Modal de "impacto" cuando un set de columnas que ya está asignado al Portal de N
 * clientes está por ser editado o eliminado en el Tablero general.
 *
 * Props:
 *  - isOpen, toggle
 *  - operation: 'update' | 'delete'
 *  - setName
 *  - assignmentsCount: int
 *  - assignedClients: [{id, name}, ...]
 *  - onChoose(action): callback con 'accept' (propagar) o 'duplicate' (solo update).
 */
export function ColumnSetPortalImpactModal({
    isOpen, toggle, operation, setName, assignmentsCount, assignedClients, onChoose,
}) {
    const { t } = useTranslation();
    const isDelete = operation === 'delete';

    const clientList = (assignedClients && assignedClients.length > 0)
        ? assignedClients.map((c) => c.name).join(', ')
        : t('column_set_portal_impact.unknown_clients');

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="md">
            <ModalHeader toggle={toggle}>
                <FaIcon iconName="triangle-exclamation" />
                {' '}{isDelete
                    ? t('column_set_portal_impact.delete_title')
                    : t('column_set_portal_impact.update_title')}
            </ModalHeader>
            <ModalBody>
                <div className="column-set-portal-impact-modal">
                    <p className="column-set-portal-impact-body">
                        {isDelete
                            ? t('column_set_portal_impact.delete_body', { name: setName, count: assignmentsCount })
                            : t('column_set_portal_impact.update_body', { name: setName, count: assignmentsCount })}
                    </p>
                    <div className="column-set-portal-impact-clients">
                        <span className="column-set-portal-impact-clients-label">
                            {t('column_set_portal_impact.assigned_to')}
                        </span>
                        <span className="column-set-portal-impact-clients-list">{clientList}</span>
                    </div>
                    {!isDelete && (
                        <ul className="column-set-portal-impact-options">
                            <li>
                                <strong>{t('column_set_portal_impact.option_accept_title')}</strong>
                                {': '}
                                {t('column_set_portal_impact.option_accept_desc')}
                            </li>
                            <li>
                                <strong>{t('column_set_portal_impact.option_duplicate_title')}</strong>
                                {': '}
                                {t('column_set_portal_impact.option_duplicate_desc')}
                            </li>
                        </ul>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('column_set_portal_impact.cancel')}
                </Button>
                {!isDelete && (
                    <button
                        type="button"
                        className="btn -negative"
                        onClick={() => onChoose(ACTION_DUPLICATE)}
                    >
                        <FaIcon iconName="copy" />
                        {' '}{t('column_set_portal_impact.duplicate_button')}
                    </button>
                )}
                <button
                    type="button"
                    className="btn -alt"
                    onClick={() => onChoose(ACTION_ACCEPT)}
                >
                    <FaIcon iconName={isDelete ? 'trash' : 'check'} />
                    {' '}{isDelete
                        ? t('column_set_portal_impact.delete_button')
                        : t('column_set_portal_impact.accept_button')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
